import { apiDateFormat, api } from 'api'
import { format } from 'date-fns'
import {
  AvgShiftStats,
  WeeklySpend,
  WorkerBench,
  Performance,
  WeeklyFillRate,
  WeeklyRatings,
} from 'typings/common_defs'

export interface InsightOptions {
  startDate: Date
  endDate: Date
  locationId?: number
  positionId?: number
}

export interface CompanyInsight {
  avgShiftStats: AvgShiftStats
  workerBench: WorkerBench
  weeklySpends: WeeklySpend
  performance: Performance
  weeklyFillRates: WeeklyFillRate[]
  weeklyRatings: WeeklyRatings[]
}

export async function getInsight(options: InsightOptions) {
  const { startDate, endDate, locationId, positionId } = options

  const response = await api.post<{ insight: CompanyInsight }>(
    '/company/graphql_dispatch/company_insight_ef6beefc',
    {
      startDate: startDate ? format(startDate, apiDateFormat) : undefined,
      endDate: endDate ? format(endDate, apiDateFormat) : undefined,
      positionId,
      locationId,
    }
  )

  return response.data.insight
}
